import { Dispatch, SetStateAction } from 'react';
import { IconLinkProps } from './IconLink';
import clsx from 'clsx';
import Button from '../../Buttons/Button/Button';

interface Props extends IconLinkProps {
  isActive: boolean;
  setIsActive: Dispatch<SetStateAction<boolean>>;
  tooltip?: string;
}

export function ButtonLink({
  icon,
  children,
  className,
  isExpanded = true,
  isSublink,
  isActive,
  disabled,
  setIsActive,
  tooltip,
}: Props) {
  const Icon = icon;
  return (
    <Button
      disabled={disabled}
      className={clsx(
        'w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-colors group relative  my-1 bg-transparent text-black outline-none shadow-none h-10 border-l-0 border-t-0 border-b-0 [&>p]:flex [&>p]:flex-row [&>p]:gap-2 [&>p]:w-full capitalize',
        isActive
          ? 'bg-primary-50 text-primary-700 hover:bg-primary-50'
          : 'hover:bg-gray-50',
        isActive && !isSublink ? 'border-r-2 border-primary-600' : 'border-none',
        isActive && isSublink ? 'rounded-r-none' : '',
        isSublink ? 'ml-6 px-2 py-2' : '',
        disabled
          ? 'text-[#999] bg-[linear-gradient(135deg,_#e4e4e4_0%,_#cccccc_100%)] hover:text-[#666] hover:bg-[linear-gradient(135deg,_#d5d5d5_0%,_#bbbbbb_100%)] hover:font-bold hover:brightness-105'
          : '',
        !isExpanded ? 'mt-2 [&>p]:justify-center' : '[&>p]:justify-start',
        className,
      )}
      onClick={() => setIsActive((state) => !state)}
      tooltip={tooltip}
      side="right"
    >
      <Icon size={20} />
      {isExpanded ? (
        <p>
          {typeof children === 'function'
            ? children({ isActive, isPending: false })
            : children}
        </p>
      ) : null}
    </Button>
  );
}
